let queryParams: any = 
{
    VehicleInformationId:"",
    DecalId: "",
    VehicleNumber: "",
    TitleState: "",
    State: "",
    License: "",
    Make: "",
    Model: "",
    Year: "",
    Color: "",
    OfficeId: "",
    AccessVehicleId: "",
    CreatedDate: "",
    CreatedBy: "",
    ModifyDate: "",
    ModifiedBy: "",
    DeletedDate: "",
    DeletedBy: "",
    DisabledDate: "",
    DisabledBy: "",
    VehicleStatusTypeId: "",
    ProfitCenterId: "",
    VinNumber: "",
    TitleNumber: "",
    PurchaseDate: "",
    PurchasePrice: "",
    LeaseNumber: "",
    LeaseExpiration: "",
    RegistrationExpiration: "",
    RegistrationState: "",
    DispositionDate: "",
    DispositionValue: "",
    BuyerName: "",
    BuyerAddress: "",
    BuyerCity: "",
    BuyerState: "",
    BuyerZip: "",
    BuyerPhone: "",
    VehicleMakeId: "",
    VehicleModelId: "",
    Mileage: "",
    MileageDate: "",
    EmployeeID: "",
    PurchasedFrom: "",
    IsOwned: "",
    MaintenanceNumber: "",
    LastReportDateTime: "",
    LastEventTypeName: "",
    Latitude: "",
    Longitude: "",
    LocationDescription: "",
    IsCartasite: null,
    VehicleRentalClassId: "",
    RentalBaseRatePerDay: "",
    RentalBaseRatePerWeek: "",
    RentalBaseRatePerMonth: "",
    RentalPickUpDate: "",
    RentalDropOffDate: "",
    RentalLicenseFees: "",
    RentalAncillaryCharges: "",
    RentalTaxes: ""
}

export default queryParams